import { useQuery } from "@tanstack/react-query";
import { get } from "@/lib/api";
import { BOOKING_STATUS, CATEGORY_LABELS, formatDate } from "@/lib/data";

export default function Bookings() {
  const { data: bookings = [] } = useQuery({ queryKey: ["admin-bookings"], queryFn: () => get("/admin/bookings") });

  return (
    <div>
      <h1 className="text-2xl font-semibold tracking-tight">Rezervasyonlar</h1>
      <p className="text-sm text-[#475569]">Tüm platform rezervasyonları · {bookings.length} kayıt</p>

      <div className="mt-5 overflow-hidden rounded border border-[#CBD5E1] bg-white">
        <table className="w-full text-sm">
          <thead className="bg-[#E2E8F0] text-left text-xs uppercase tracking-wide text-[#475569]">
            <tr><th className="px-4 py-2.5">Müşteri</th><th className="px-4 py-2.5">Stüdyo</th><th className="px-4 py-2.5">Kategori</th><th className="px-4 py-2.5">Tarih</th><th className="px-4 py-2.5">Durum</th><th className="px-4 py-2.5 text-right">Kredi</th></tr>
          </thead>
          <tbody className="divide-y divide-[#F1F5F9]">
            {bookings.map((b) => {
              const st = BOOKING_STATUS[b.status];
              return (
                <tr key={b.id} className="hover:bg-[#F8FAFC]">
                  <td className="px-4 py-2.5 font-medium">{b.user_name}</td>
                  <td className="px-4 py-2.5 text-[#475569]">{b.studio_name}</td>
                  <td className="px-4 py-2.5 text-[#475569]">{CATEGORY_LABELS[b.category]}</td>
                  <td className="px-4 py-2.5 text-[#475569]">{formatDate(b.date)} · {b.start_time}</td>
                  <td className="px-4 py-2.5"><span className={`rounded border px-2 py-0.5 text-xs font-medium ${st.color}`}>{st.label}</span></td>
                  <td className="px-4 py-2.5 text-right font-medium">{b.credit_price}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
